
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import 'tinymce/tinymce';
import 'tinymce/models/dom';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
// import 'tinymce/themes/oxide-dark';
// import 'tinymce/plugins/paste';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/plugins/accordion';

// import 'tinymce/skins/ui/oxide-dark/skin.min.css';
// import 'tinymce/skins/ui/oxide-dark/content.min.css';

import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';

import 'tinymce/skins/content/default/content.min.css';

import Isvg from 'react-inlinesvg';
import { Editor } from '@tinymce/tinymce-react';

class Html extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div className="input-wrap">
                <label>{this.props.translate(this.props.label)}</label>
                <Editor
                    // apiKey="lweh8ghdiwccyg0ogbblrkzamnybbrxoay2b7ontj3tusq7c"
                    init={{ plugins: 'link table', height: 300 }}
                    value={this.props.multilang ? (this.props.value && this.props.value[this.props.lang]) ? this.props.value[this.props.lang] : '' : this.props.value}
                    onEditorChange={(val) => {

                        if (this.props.multilang) {
                            let value = this.props.value;
                            if (!value) {
                                value = {};
                            }
                            value[this.props.lang] = val;
    
                            this.props.onChange(value);
                        } else {
    
                            this.props.onChange(val);
                        }
                        this.forceUpdate();
    
    
                    }}
                />
            </div>
        );
    }
}

export default Html;